export const PlaceholderHallOfFameGameCard = () => (
    <div className="slider-item">
        <div className="card h-100 border-dark">
            <div className="card-header bg-dark hstack gap-2 px-2" style={{ height: 75 }}>
                <span
                    className="fs-5 placeholder bg-light rounded"
                    style={{ width: "1.5rem", height: "1.5rem" }}
                ></span>
                <div
                    className="h6 placeholder bg-light rounded align-self-center"
                    style={{ width: "120px", height: "1rem" }}
                ></div>
            </div>

            <div className="placeholder bg-secondary" style={{ height: 190 }} />

            <div className="card-body px-2 d-flex flex-column border-top border-dark">
                <div className="mt-auto">
                    <div className="hstack gap-2 small ms-1 justify-content-between">
                        <div className="d-flex align-items-center gap-1 lh-1">
                            <div
                                className="placeholder bg-secondary rounded"
                                style={{ width: "80px", height: "0.75rem" }}
                            ></div>
                            <div
                                className="placeholder bg-secondary rounded"
                                style={{ width: "16px", height: "12px" }}
                            ></div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center lh-1">
                            <div
                                className="placeholder bg-secondary rounded"
                                style={{ width: "30px", height: "0.75rem" }}
                            ></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
);
